<p-toast></p-toast>
<div class="container-fluid container-fullw">
  <div class="p-fluid p-grid">
    <div class="p-col-12">
      <div>
        <p-fieldset [toggleable]="true">
          <ng-template pTemplate="header">
            <span *ngIf="like.id === null">{{ 'NEWLIKE' | translate }}</span>
            <span *ngIf="like.id !== null">{{ 'EDITLIKE' | translate }}</span>
          </ng-template>
          <form pFocusTrap name="likeForm" id="likeForm" novalidate (ngSubmit)="submitForm(true)" [formGroup]="likeForm" >
            <input type="hidden" name="id" id="likeId" formControlName="id" />
            <div class="p-fluid p-grid">
              <div class="p-col-6">

                <div class="p-field p-col-12">
                  <div class="p-inputgroup">
                    <span class="p-inputgroup-addon">
                      <i class="fas fa-table "></i>
                    </span>
                    <span class="p-float-label">
                      <input id="likeEntity" formControlName="entity" type="text" pInputText [required]="true"> 
                      <label for="likeEntity" class="req">{{ 'ENTITY' | translate }}</label>
                    </span>
                  </div>
                </div>
                <div *ngIf="likeForm.controls['entity'].invalid && (likeForm.controls['entity'].dirty || likeForm.controls['entity'].touched)" class="alert alert-danger">
                  <ng-container *ngIf="likeForm.controls['entity'].errors !== null">
                  <div *ngIf="likeForm.controls['entity'].errors.required">
                   {{ 'ENTITYREQUIRED' | translate }}.
                  </div>
                  </ng-container>
                </div>

              </div><!--/p-col-6-->
              <div class="p-col-6">

                <div class="p-field p-col-12">
                  <div class="p-inputgroup">
                    <span class="p-inputgroup-addon">
                      <i class="fas fa-project-diagram "></i>
                    </span>
                    <span class="p-float-label">
                      <p-inputNumber inputId="likeForeignKey" formControlName="foreignKey" [step]="1" [showButtons]="true" [required]="true"></p-inputNumber>
                      <label for="likeForeignKey" class="req">{{ 'FOREIGNKEY' | translate }}</label>
                    </span>
                  </div>
                </div>
                <div *ngIf="likeForm.controls['foreignKey'].invalid && (likeForm.controls['foreignKey'].dirty || likeForm.controls['foreignKey'].touched)" class="alert alert-danger">
                  <ng-container *ngIf="likeForm.controls['foreignKey'].errors !== null">
                  <div *ngIf="likeForm.controls['foreignKey'].errors.required">
                   {{ 'FOREIGNKEYREQUIRED' | translate }}.
                  </div>
                  </ng-container>
                </div>

              </div><!--/p-col-6-->
            </div><!--/p-fluid p-grid-->
            <div class="p-fluid p-grid">
              <div class="p-col-6">

                <div class="p-field p-col-12">
                  <div class="p-inputgroup">
                    <span class="p-inputgroup-addon">
                      <i class="fas fa-gem "></i>
                    </span>
                    <span class="p-float-label">
                      <p-inputNumber inputId="likeValue" formControlName="value" [step]="1" [showButtons]="true" [required]="true"></p-inputNumber>
                      <label for="likeValue" class="req">{{ 'VALUE' | translate }}</label>
                    </span>
                  </div>
                </div>
                <div *ngIf="likeForm.controls['value'].invalid && (likeForm.controls['value'].dirty || likeForm.controls['value'].touched)" class="alert alert-danger">
                  <ng-container *ngIf="likeForm.controls['value'].errors !== null">
                  <div *ngIf="likeForm.controls['value'].errors.required">
                   {{ 'VALUEREQUIRED' | translate }}.
                  </div>
                  </ng-container>
                </div>

              </div><!--/p-col-6-->
            </div><!--/p-fluid p-grid-->

            <div class="p-fluid p-grid">
              <div class="p-col-4">
                <button (click)="list()" class="btn btn-primary pull-left">
                  <i class="icon-layout-list-thumb"></i>
                  <span class="p-ml-1">{{ 'BACKLIKES' | translate }}</span>
                </button>
              </div>
              <div class="p-col-4 text-center">
                <button *ngIf="like.id !== null" type="button" (click)="submitForm(false)" class="btn btn-primary" [disabled]="!likeForm.valid || disableSubmit"> <!--  [disabled]="likeForm.$invalid" -->
                  <i class="fas fa-spinner fa-spin" *ngIf="disableSubmit && !redirect"></i>
                  <i class="fas fa-check-circle" *ngIf="!(disableSubmit && !redirect)"></i>
                  <span class="p-ml-1"> {{ 'APPLY' | translate }}</span>
                </button>
              </div>
              <div class="p-col-4">
                <button type="button" (click)="submitForm(true)" class="btn btn-primary pull-right" [disabled]="disableSubmit"> <!--  [disabled]="!likeForm.valid || " -->
                  <i class="fas fa-spinner fa-spin" *ngIf="disableSubmit && redirect"></i>
                  <i class="icon-save" *ngIf="!(disableSubmit && redirect)"></i>
                  <span class="p-ml-1">{{ 'SAVE' | translate }}</span>
                </button>
              </div>
            </div>
          </form>
        </p-fieldset>
        <div class="p-fluid p-grid">
          <div class="col-sm-12 p-col-4 mb-2">
          </div>
          <div class="col-sm-12 p-col-4 mb-2 text-center">
          </div>
          <div class="col-sm-12 p-col-4 mb-2">
          </div>
        </div>
      </div>
    </div><!--/p-col-12-->
  </div><!--/p-fluid p-grid-->
  <p-scrollTop target="parent"></p-scrollTop>
</div><!--/container-fluid container-fullw-->
<!-- end: FORM -->

